'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "value", "filterFamily", "getFilterFamilyObjectName"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorIncludeObjectsWithNoAssociatedObjectsInput = props => {
  const {
      onChange,
      value,
      filterFamily,
      getFilterFamilyObjectName
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const onCheckboxChange = useCallback(evt => {
    onChange(evt.target.checked);
  }, [onChange]);
  const associatedObjectName = getFilterFamilyObjectName(filterFamily, true);
  return /*#__PURE__*/_jsxs(UICheckbox, Object.assign({
    checked: value,
    onChange: onCheckboxChange,
    size: "small",
    style: {
      minHeight: 'auto'
    }
  }, rest, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjects",
      options: {
        associatedObjectName
      }
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UITooltip, {
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipHeading"
      }),
      placement: "left",
      title: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody1",
            options: {
              associatedObjectName
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody2"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipBody3"
          })
        })]
      }),
      use: "longform",
      children: /*#__PURE__*/_jsx(UILink, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterOperatorInput.includeObjectsWithNoAssociatedObjectsTooltipButtonLabel"
        })
      })
    })]
  }));
};
FilterOperatorIncludeObjectsWithNoAssociatedObjectsInput.propTypes = {
  filterFamily: PropTypes.string.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool
};
export default FilterOperatorIncludeObjectsWithNoAssociatedObjectsInput;